import {
  type TicketQuantityLimits,
  resolveTicketQuantityLimitState,
} from "@project-x/ui-kit";

export interface TicketSelectionOption {
  id: string;
  limits: TicketQuantityLimits;
  price?: number; // Add price in cents
}

export interface CheckoutSelectionItem {
  ticketTypeId: string;
  quantity: number;
  price?: number; // Add price in cents for display/validation
  perUserLimit?: number; // Add per user limit for validation
}

export const buildSelectionPayload = (
  quantities: Record<string, number>,
  ticketPrices?: Record<string, number>,
  ticketLimits?: Record<string, TicketQuantityLimits>
): CheckoutSelectionItem[] =>
  Object.entries(quantities)
    .filter(([, quantity]) => quantity > 0)
    .map(([ticketTypeId, quantity]) => ({ 
      ticketTypeId, 
      quantity,
      price: ticketPrices?.[ticketTypeId],
      perUserLimit: ticketLimits?.[ticketTypeId]?.perUserLimit ?? undefined
    }));

export const totalSelectedTickets = (quantities: Record<string, number>): number =>
  Object.values(quantities).reduce((sum, quantity) => sum + quantity, 0);

export const isSelectionValid = (
  options: TicketSelectionOption[],
  quantities: Record<string, number>
): boolean =>
  options.every((option) => {
    const quantity = quantities[option.id] ?? 0;
    if (quantity === 0) {
      return true;
    }
    const state = resolveTicketQuantityLimitState(option.limits);
    if (!state.selectable) {
      return false;
    }
    if (quantity < state.minimum) {
      return false;
    }
    if (state.maximum !== undefined && quantity > state.maximum) {
      return false;
    }
    return true;
  });
